// resolve link path
// https://www.storyblok.com/docs/guide/in-depth/rendering-the-link-field
export const Href = (link) => {
  if (!link) return null
  if (!link.cached_url) return null
  return link.linktype === 'story' ? `/${link.cached_url}` : link.cached_url
}
